import './item.css';
import styled from 'styled-components';
import React from 'react';


const Frame = styled.div`
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;

  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
  }
  margin: 16px;
  flex: 0 0 10%;
  flex-basis: 20rem;
  position: relative;
  cursor: pointer;
`;

const Image = styled.img`
  width: 100%;
`;

const ImageContainer = styled.div`
  overflow: hidden;
  transition: 0.3s;
  max-height: 60%;
  &:hover {
    max-height: auto;
  }
`;

const TextContainer = styled.div`
  background-color: white;
  width: 100%;
`;

const Header = styled.div`
  text-align: center;
  font-size: 1.2rem;
`;

const TextPadding = styled.div`
  padding: 10px 16px;
`;

export default function({ item: { itemUrl, imageUrl, id, ended, endsAt, descriptionData = {}, location} }) {
  const { description, condition } = descriptionData;
  return (
    <Frame onClick={() => window.open(itemUrl, '_blank')}>
      <ImageContainer>
        <Image src={imageUrl} />
      </ImageContainer>
      <TextContainer>
        <TextPadding>
          <Header>
            {description}
          </Header>
          <ul>
            <li>Condition: {condition}</li>
            <li>Location: {location}</li>
            <li>Ends At: {new Date(endsAt).toLocaleString()}</li>
          </ul>
        </TextPadding>
      </TextContainer>
    </Frame>
  )
}


// WEBPACK FOOTER //
// ./src/components/item.js